import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import * as _ from 'lodash';
import { ActivatedRoute, Router } from '@angular/router';
import { TixxSelectTranslationsService } from '~shared/translations';
import { SpinnerService } from '~shared/components/buttons/spinner/spinner.service';
import { NotificationType } from '~core/enum';
import { ButtonsTranslations } from '~shared/components/buttons/buttons-translations.service';
import { FormLabelTranslationService } from '~shared/components/form-fields/translations/form-label-translations.service';
import { AttributeService, DefaultNotificationService, TixxSelectSubmissionService } from '~core/services';
import { Club, Lottery, LotteryExecutionResults } from '~core/models';

/**
 * Component that displays the lottery results step of the execution process
 */
@UntilDestroy()
@Component({
  selector: 'app-lottery-results',
  templateUrl: './lottery-results.component.html',
  styleUrls: ['../../../lottery-execution.component.scss']
})

export class LotteryResultsComponent implements OnInit {
  @Input() public selectedLottery: Lottery;
  @Input() public selectedClub: Club;
  @Input() public executionResults: LotteryExecutionResults;
  @Output() public nextStepEmitter: EventEmitter<any> = new EventEmitter(null);

  public spinnerName: string = 'seatingLoading';

  constructor(
    protected attributeService: AttributeService,
    public buttonsTranslations: ButtonsTranslations,
    public flTranslations: FormLabelTranslationService,
    private submissionService: TixxSelectSubmissionService,
    private notificationService: DefaultNotificationService,
    private tixxSelectTranslationService: TixxSelectTranslationsService,
    private spinnerService: SpinnerService,
    private router: Router,
    private route: ActivatedRoute,
  ) { }

  ngOnInit(): void { }

  public createReservations(): void {
    this.spinnerService.show(this.spinnerName);
    const data = { iterationId: this.executionResults.id };

    this.submissionService.postIterationReservation(data).pipe(untilDestroyed(this))
      .subscribe(res => {
        this.notificationService.showNotification({
          type: NotificationType.SUCCESS,
          message: this.tixxSelectTranslationService.i18nLotterySeatingInitiated
        });
        this.router.navigate(['../'], { relativeTo: this.route });
      });
  }

}
